import ApiService from '@/services/core/api.service'

const BrandService = {
  async get (query) {
    return ApiService.get(`admin/brands?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/brands', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/brands/${payload.id}`, payload)
  }
}

export default BrandService
